<template>
    <div class="date-locale-picker">
        <div class="search-panel">
            <input maxlength="128" :placeholder="$t('chatbotv2.typeSearchValue')" type="text" v-model="search" />
            <span class="material-icons"> search </span>
        </div>
        <div class="entity-list">
            <div class="entity-select">
                <div class="text-uppercase caption">Locales</div>
                <div
                    class="picker-item"
                    v-for="item of getFilteredItems()"
                    @click="pick(item.value)"
                    :class="{ active: value === item.value }"
                >
                    <span class="name">{{ item.description }} </span>
                    <span class="description">{{ item.example }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
    name: "DateLocalePicker",
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        const locales = [
            "en",
            "af",
            "ar-dz",
            "ar-kw",
            "ar-ly",
            "ar-ma",
            "ar-ps",
            "ar-sa",
            "ar-tn",
            "ar",
            "az",
            "be",
            "bg",
            "bm",
            "bn-bd",
            "bn",
            "bo",
            "br",
            "bs",
            "ca",
            "cs",
            "cv",
            "cy",
            "da",
            "de-at",
            "de-ch",
            "de",
            "dv",
            "el",
            "en-au",
            "en-ca",
            "en-gb",
            "en-ie",
            "en-il",
            "en-in",
            "en-nz",
            "en-sg",
            "eo",
            "es-do",
            "es-mx",
            "es-us",
            "es",
            "et",
            "eu",
            "fa",
            "fi",
            "fil",
            "fo",
            "fr-ca",
            "fr-ch",
            "fr",
            "fy",
            "ga",
            "gd",
            "gl",
            "gom-deva",
            "gom-latn",
            "gu",
            "he",
            "hi",
            "hr",
            "hu",
            "hy-am",
            "id",
            "is",
            "it-ch",
            "it",
            "ja",
            "jv",
            "ka",
            "kk",
            "km",
            "kn",
            "ko",
            "ku-kmr",
            "ku",
            "ky",
            "lb",
            "lo",
            "lt",
            "lv",
            "me",
            "mi",
            "mk",
            "ml",
            "mn",
            "mr",
            "ms-my",
            "ms",
            "mt",
            "my",
            "nb",
            "ne",
            "nl-be",
            "nl",
            "nn",
            "oc-lnc",
            "pa-in",
            "pl",
            "pt-br",
            "pt",
            "ro",
            "ru",
            "sd",
            "se",
            "si",
            "sk",
            "sl",
            "sq",
            "sr-cyrl",
            "sr",
            "ss",
            "sv",
            "sw",
            "ta",
            "te",
            "tet",
            "tg",
            "th",
            "tk",
            "tl-ph",
            "tlh",
            "tr",
            "tzl",
            "tzm-latn",
            "tzm",
            "ug-cn",
            "uk",
            "ur",
            "uz-latn",
            "uz",
            "vi",
            "x-pseudo",
            "yo",
            "zh-cn",
            "zh-hk",
            "zh-mo",
            "zh-tw",
        ];
        return {
            list: locales.map((x) => ({
                value: x,
                description: x,
                example: "",
            })),
            clone: _.cloneDeep(this.value),
            search: "",
        };
    },
    methods: {
        pick(value) {
            this.clone = value;
        },
        getFilteredItems() {
            const q = this.search.toLowerCase().trim();
            if (q.length === 0) return this.list;
            else return this.list.filter((x) => x.description.toLowerCase().includes(q));
        },
    },
    computed: {
        ...mapState({}),
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (newValue !== this.clone) this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.date-locale-picker {
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    max-height: 600px;
    min-height: 200px;
    user-select: none;
    width: 100%;
    padding: 5px;

    .search-panel {
        align-items: center;
        border-bottom: 1px solid #e8eef3;
        display: flex;
        flex-shrink: 0;
        position: relative;
        width: 100%;

        input {
            background: transparent;
            border: 0;
            font-size: 16px;
            height: 40px;
            line-height: 20px;
            padding-left: 45px;
            padding-right: 15px;
            width: 100%;
        }

        span {
            color: #9ba6b3;
            font-size: 18px;
            left: 15px;
            pointer-events: none;
            position: absolute;
            -webkit-transition: color 0.3s;
            transition: color 0.3s;
        }
    }

    .entity-list {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 15px 0;
    }

    .entity-select {
        .caption {
            margin-bottom: 10px;
            padding: 0 15px;
            color: #9ba6b3;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }
    }

    .picker-item {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 32px;
        padding: 0 15px;
        -webkit-transition: background-color 0.2s, opacity 0.2s;
        transition: background-color 0.2s, opacity 0.2s;

        &.active {
            color: #006cff !important;

            .material-icons,
            .name,
            .description {
                color: #006cff !important;
            }
        }

        &:hover {
            background-color: #f0f4f7;
        }

        .material-icons {
            color: #647283;
            font-size: 15px;
            margin-right: 11px;
        }

        .name {
            color: #22272d;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            margin-right: 20px;
        }

        .description {
            color: #9ba6b3;
            font-size: 15px;
            line-height: 19px;
            margin-left: auto;
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
